import { JensiatEnum } from 'Feature/Common/Common/Types/Enums/JensiatEnum';

import StepOneModelInitialState from '../Components/01-StepOne/Models/StepOneModelInitialState';
import StepTwoModelInitialState from '../Components/02-StepTwo/Models/StepTwoModelInitialState';
import StepThreeModelInitialState from '../Components/03-StepThree/Models/StepThreeModelInitialState';
import StepFourModelInitialState from '../Components/04-StepFour/Models/StepFourModelInitialState';
import StepFifthModelInitialState from '../Components/05-StepFifth/Models/StepFifthModelInitialState';
import StepSixModelInitialState from '../Components/06-StepSix/Models/StepSixModelInitialState';

import AddressInitialState from './InitialStates/AddressInitialState';
import BimehMarkaziInitialStateSodoor from './InitialStates/BimehMarkaziInitialStateSodoor';
import BimehNamehInitialState from './InitialStates/BimehNamehInitialState';
import { BimehNamehInitialStateSodoor } from './InitialStates/BimehNamehInitialStateSodoor';
import SherkatBimehGhablInitialState from './InitialStates/SherkatBimehGhablInitialState';
import VehicleInfoInitialState from './InitialStates/VehicleInfoInitialState';
import { VehicleInfoInitialStateSodoor } from './InitialStates/VehicleInfoInitialStateSodoor';
import ShakhsSalesBimehNamehEstelamAndSodoorSliceType from './ShakhsSalesBimehNamehEstelamAndSodoorSliceType';

const ShakhsSalesBimehNamehEstelamAndSodoorInitialState: ShakhsSalesBimehNamehEstelamAndSodoorSliceType = {
  stepOneData: StepOneModelInitialState,
  stepTwoData: StepTwoModelInitialState,
  stepThreeData: StepThreeModelInitialState,
  stepFourData: StepFourModelInitialState,
  stepFiveData: StepFifthModelInitialState,
  stepSixData: StepSixModelInitialState,
  anvaeVasilehNaghleyeh: {
    loading: false,
    data: [],
  },
  moredEstefadehHayeKhodro: {
    loading: false,
    data: [],
  },
  brandHa: {
    loading: false,
    data: [],
  },
  moddatHayeBimehNameh: {
    loading: false,
    data: [],
  },
  getAddressWithPostCode: {
    loading: false,
    data: null,
  },
  estelamSabtAhval: {
    loading: false,
    data: {
      naam: '',
      naamKhanevadegi: '',
      jensiat: JensiatEnum.MARD,
      tarikhTavallod: new Date(),
    },
  },
  tipHa: {
    loading: false,
    data: [],
  },
  anvaePelak: {
    loading: false,
    data: [],
  },
  rangHa: {
    loading: false,
    data: [],
  },
  harfHayePelak: {
    loading: false,
    data: [],
  },
  rangHaLabelValueType: {
    loading: false,
    data: [],
  },
  taahodatSalesJaani: {
    loading: false,
    data: undefined,
  },
  taahodatSalesMali: {
    loading: false,
    data: [],
  },
  takhfifHayeJarimehSales: {
    loading: false,
    data: [],
  },
  takhfifHayeJarimehSarneshin: {
    loading: false,
    data: [],
  },
  tarhTakhfif: {
    loading: false,
    data: [],
  },
  taahodatSalesSarneshin: {
    loading: false,
    data: undefined,
  },
  wizard: {
    begin: 1,
    end: 6,
    current: 1,
  },

  estelamSalesResult: {
    loading: false,
    loaded: false,
    data: null,
  },
  bimehNamehExpireDateMaxDay: {
    loading: false,
    data: 0,
  },
  isSuccess: false,
  haghBimehPardakhti: 0,
  taahodatMaliEstelamResult: undefined,
  getCodeShenasehPardakhtShakhsSalesCommand: {
    bimehNameh: BimehNamehInitialStateSodoor,
    ranandehHa: [],
    tarafHayeGharardad: [],
    address: AddressInitialState,
    vasilehNaghlieh: VehicleInfoInitialStateSodoor,
    bimehMarkazi: BimehMarkaziInitialStateSodoor,
    sherkatBimehGhabl: SherkatBimehGhablInitialState,
  },

  isMablaghKharidBimehNamehMoreThanHaghBimeh: false,

  estelamShakhsSalesCommand: {
    vehicleInfo: VehicleInfoInitialState,
    bimehNameh: BimehNamehInitialState,

    shadowFields: {
      vaziatBimehNamehGhabli: true,
      khesaratDaryaftKardehEed: false,
    },
  },

  estelamBimehMarkaziModel: {
    estelamBimehMarkaziOption: null,
    shomarehBimehNameh: '',
    shomarehMotor: '',
    shomarehShasi: '',
    codeYektaBimehMarkazi: '',
  },

  showConfirmFromUser: false,

  estelamBimehMarkaziResult: {
    loading: false,
    data: null,
  },

  countries: {
    loading: false,
    data: [],
  },

  anvaeSherkatBimeh: {
    loading: false,
    data: [],
  },

  getCodeShenasehPardakhtShakhsSalesResult: {
    loading: false,
    data: null,
  },

  serialPelaks: {
    loading: false,
    data: [],
  },

  addToOrderResponse: {
    loading: false,
  },
  niazBeEstelamBimehMarkazi: false,

  isDuplicateBimehNamehInOrder: {
    loading: false,
    data: null,
  },
};

export default ShakhsSalesBimehNamehEstelamAndSodoorInitialState;
